function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fb91716e\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./G-header.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./G-header.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fb91716e\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./G-header.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/G-header.vue
// module id = 14
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15 16 17